/**
 * @file config
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { createContext, useContext } from 'react';
export var DEFAULT_CONFIG_OPTIONS = {
  prefix: 'adp'
};
var Context = createContext(DEFAULT_CONFIG_OPTIONS);
var Provider = Context.Provider;
export { Provider };
export function useConfig() {
  return useContext(Context);
}